export enum Playback {
  Roll = 'roll',
  Play = 'play',
  Pause = 'pause',
  Stop = 'stop',
  Armed = 'armed',
}
